import axios from "axios";


// LOCAL
// const insertarTurno = async (payLoad, setCarga) => {
//     setCarga(true);
//     console.log(payLoad)

//     const resp = await axios.post("http://localhost:3000/turnera/apiTurnera/index.php/api/turnos/add", payLoad);
//     console.log(resp)
//     setCarga(false);
//     return (resp.data);
// }

// const buscarTurnos = async (datos, setCarga) => {
//     setCarga(true);

//     const resp = await axios.post("http://localhost:3000/turnera/apiTurnera/index.php/api/turnos/buscaTurno/", datos);
//     console.log(resp.data);
//     setCarga(false);
//     return (resp.data);

// }

// const cancelarTurno = async (DNI, codigoTurno, setCarga) => {
//     setCarga(true);

//     const resp = await axios.post(`http://localhost:3000/turnera/apiTurnera/index.php/api/turnos/cancela/${codigoTurno}/${DNI}`, null);
//     console.log(resp.data);
//     setCarga(false);
//     return (resp.data);

// }



// DEV SERVER
// const insertarTurno = async (payLoad, setCarga) => {
//     setCarga(true);
//     console.log(payLoad)

//     const resp = await axios.post("http://10.100.18.213/turnera/apiTurnera/index.php/api/turnos/add", payLoad);
//     setCarga(false);
//     return (resp.data);
// }

// const buscarTurnos = async (datos, setCarga) => {
//     setCarga(true);

//     const resp = await axios.post("http://10.100.18.213/turnera/apiTurnera/index.php/api/turnos/buscaTurno/", datos);
//     console.log(resp.data);
//     setCarga(false);
//     return (resp.data);

// }

// const cancelarTurno = async (DNI, codigoTurno, setCarga) => {
//     setCarga(true);

//     const resp = await axios.post(`http://10.100.18.213/turnera/apiTurnera/index.php/api/turnos/cancela/${codigoTurno}/${DNI}`, null);
//     console.log(resp.data);
//     setCarga(false);
//     return (resp.data);

// }


// PROD
const insertarTurno = async (payLoad, setCarga) => {
    setCarga(true);

    const resp = await axios.post("https://api-turnera.vicentelopez.gov.ar/api/turnos/add", payLoad);
    setCarga(false);
    return (resp.data);
}

const buscarTurnos = async (datos, setCarga) => {
    setCarga(true);

    const resp = await axios.post("https://api-turnera.vicentelopez.gov.ar/api/turnos/buscaTurno/", datos);
    setCarga(false);
    return (resp.data);

}

const cancelarTurno = async (DNI, codigoTurno, setCarga) => {
    setCarga(true);

    const resp = await axios.post(`https://api-turnera.vicentelopez.gov.ar/api/turnos/cancela/${codigoTurno}/${DNI}`, null);
    setCarga(false);
    return (resp.data);

}



export {
    insertarTurno,
    buscarTurnos,
    cancelarTurno,
}